import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="dark-footer">
      <div className="footer-content">
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-section">
            <img 
              src="https://customer-assets.emergentagent.com/job_fabsome-services/artifacts/pruq3r2h_Fabsome%20Logo%20cropped.PNG" 
              alt="Fabsome Consulting" 
              className="footer-logo"
            />
            <p className="footer-description">
              Professional consulting services for businesses in the UAE. Your trusted partner for compliance, advisory, and growth.
            </p>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h3 className="footer-heading">Quick Links</h3>
            <nav className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/about" className="footer-link">About Us</Link>
              <Link to="/services" className="footer-link">Our Services</Link>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h3 className="footer-heading">Contact Information</h3>
            <div className="footer-contact">
              <div className="contact-item">
                <MapPin size={18} />
                <span>M1 Floor, Twin Towers, Fujairah, PO Box 4422, UAE</span>
              </div>
              <div className="contact-item">
                <Phone size={18} />
                <a href="tel:+971521034853">+971 52 103 4853</a>
              </div>
              <div className="contact-item">
                <Mail size={18} />
                <a href="mailto:info@fabsome.ae">info@fabsome.ae</a>
              </div>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="footer-bottom">
          <p>© 2025 Fabsome Consulting FZ LLE. All rights reserved.</p>
          <p className="footer-website">www.fabsome.ae</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;